import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { TRANSFER_LINK_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import {
  TransferOwnershipLinkRequest,
  TransferOwnershipLinkResponse,
} from './types';

export function useTransferOwnershipLinkMutationApi(id: string) {
  return useBaseMutation<
    TransferOwnershipLinkRequest,
    TransferOwnershipLinkResponse
  >({
    url: `${TRANSFER_LINK_ROOT_ENDPOINT}/${id}`,
    method: HttpMethod.put,
    params: {
      action: 'accept',
    },
  });
}
